import { Container } from "./styles";
import Toast from "./Toast";
import { ToastMessage } from "../../hooks/toast";

interface ToastContainerProps {
  messages: ToastMessage[];
  removeToast: (id: string) => void;
}

const ToastContainer = ({ messages, removeToast }: ToastContainerProps) => {

  return (
    <Container>
      {messages.map(message => (
        <Toast key={message.id} message={message} onRemove={removeToast} />
      ))}
    </Container>
  );
};

export default ToastContainer;
